import { createAction, props } from "@ngrx/store";

export const go = createAction(
  "[Router] Go",
  props<{ payload: { path: string[]; query?: object; extras?: object } }>()
);
export const back = createAction("[Router] Back");
export const forward = createAction("[Router] Forward");
